import { formatDateTimeFull } from '~/models/dateTime'

/**
 * 入札一覧の「作成」列 (通常入札 AC-BSP-001 / ブロック入札 AC-BSP-028) の表示文字列
 * (design `spot.html` `.col-audit`「名前 yyyy/MM/dd HH:mm」)。 年を出すのは #10124
 * (日をまたぐ運用で取り違えないため。 時間前入札 AC-BIN-047 と同じ書式)。
 *
 * created_by は eauth member ID なので生値を画面に出さず、 [[useMemberDisplayName]] で
 * 解決した表示名を受け取る。 解決できない時 (eBalance 以外から取り込んだ札 = AC-BSP-112 を
 * 含む) は作成日時だけを出す。
 */
export const formatCreatedLabel = (
  createdByName: string | undefined,
  createdAt: Date,
): string => {
  const createdAtLabel = formatDateTimeFull(createdAt)
  return createdByName !== undefined
    ? `${createdByName} ${createdAtLabel}`
    : createdAtLabel
}
